/**
 * Заголовок страницы объекта.
 *
 * На телефоне колонки со списком объектов нет — заголовок сам служит
 * переключателем: «MAG 042 ⌄» открывает панель выбора другого объекта.
 * На компьютере и планшете это обычный заголовок.
 */
import { useDispatch } from 'react-redux';

import { toggleMobileSidebar } from '../../store/slices/uiSlice';
import Icon from './Icon';
import styles from './ObjectTitle.module.css';

export default function ObjectTitle({ className, children }) {
  const dispatch = useDispatch();
  return (
    <h1 className={className}>
      <span className={styles.text}>{children}</span>
      <button
        type="button"
        className={styles.switch}
        onClick={() => dispatch(toggleMobileSidebar())}
        aria-haspopup="dialog"
      >
        {children}
        <span className={styles.chevron} aria-hidden="true"><Icon name="chevron" size={16} /></span>
        <span className={styles.srOnly}>: выбрать другой объект</span>
      </button>
    </h1>
  );
}
